// @ts-nocheck

// Helper: debounce function
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  class CheckoutHandler {
    constructor() {
      // Initialize properties - FR only
      this.country = 'FR';
      this.currency = 'EUR';
      this.language = 'FR';
      this.maxCartValue = 6000; // 60€ in cents
      
      // Checkout configuration
      this.sourceId = 'nayaliya.com';
      this.logoUrl = 'https://cdn.shopify.com/s/files/1/0931/0751/9875/files/nayalia.png?v=1763129817';
      this.shopColor = '000000';
      this.shopReviews = '3782';
      this.trackingPixel = 'D2RANCJC77UBOEFA1U90';
  
      // FR tier pricing - all available price points sorted from lowest to highest
      this.tiers = [
        { price: 200 },   // €2.00
        { price: 295 },   // €2.95
        { price: 395 },   // €3.95
        { price: 495 },   // €4.95
        { price: 595 },   // €5.95
        { price: 699 },   // €6.99
        { price: 795 },   // €7.95
        { price: 999 },   // €9.99
        { price: 1190 },  // €11.90
        { price: 1399 },  // €13.99
        { price: 1495 },  // €14.95
        { price: 1795 },  // €17.95
        { price: 1999 },  // €19.99
        { price: 2495 },  // €24.95
        { price: 2995 },  // €29.95
        { price: 3999 },  // €39.99
        { price: 4999 }   // €49.99
      ];
  
      // Text strings
        this.texts = {
            cartCheckout: 'COMMANDER',
        cartLimitError: 'Le panier est limité à 60€ maximum',
        bundleDiscount: 'Remise Panier'
      };
  
        this.source = "nayaliya";
        this.fbPixelId = "1129542845831722";
        
      // Set global variables
      window.currentCountry = this.country;
      window.currentCurrency = this.currency;
      window.currentLanguage = this.language;
        
        this.init();
        
      // Add minimal CSS for cart styling
        const style = document.createElement('style');
        style.textContent = `
        /* Cart styling */
          .cart, .cart-drawer, .cart-drawer__content {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important;
          }
          
        /* Cart summary */
        .cart-summary, .totals, .cart__footer {
          background: transparent;
          border: none;
          border-radius: 0;
          padding: 0;
          margin: 0;
        }
        
        /* Loading overlay for cart updates */
        .cart-updating-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 100;
          backdrop-filter: blur(4px);
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.2s ease;
        }
        
        .cart-updating-overlay.active {
          opacity: 1;
          pointer-events: all;
        }
        
        .cart-loader {
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #E86DAA;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Shimmer effect for updating elements */
        .cart-shimmer {
          position: relative;
          overflow: hidden;
        }
        
        .cart-shimmer::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
          animation: shimmer 1.2s infinite;
        }
        
        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 100%; }
        }
        
        /* Cart error messages - prominent notifications */
        .cart-error-message {
          background: linear-gradient(135deg, #E86DAA, #D65A95);
          border: 2px solid rgba(255, 255, 255, 0.3);
          color: white;
          padding: 1.25rem 2rem;
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 600;
          text-align: center;
          position: fixed;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 10001;
          box-shadow: 0 12px 32px rgba(232, 109, 170, 0.4), 0 4px 12px rgba(0, 0, 0, 0.15);
          animation: errorSlideDown 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
          min-width: 320px;
          max-width: 90vw;
          backdrop-filter: blur(10px);
        }
        
        .cart-error-message::before {
          content: "⚠️ ";
          font-size: 1.2rem;
          margin-right: 0.5rem;
        }
        
        @keyframes errorSlideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-30px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
        }
        
        @keyframes errorSlideUp {
          from {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
          to {
            opacity: 0;
            transform: translateX(-50%) translateY(-30px) scale(0.9);
          }
        }
        
        /* Success message for cart updates */
        .cart-success-message {
          background: linear-gradient(135deg, #22c55e, #16a34a);
          border: 2px solid rgba(255, 255, 255, 0.3);
          color: white;
          padding: 1rem 1.5rem;
          border-radius: 12px;
          font-size: 0.95rem;
          font-weight: 600;
          text-align: center;
          position: fixed;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 10001;
          box-shadow: 0 12px 32px rgba(34, 197, 94, 0.3);
          animation: errorSlideDown 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
          min-width: 280px;
          max-width: 90vw;
        }
        
        .cart-success-message::before {
          content: "✓ ";
          font-size: 1.2rem;
          margin-right: 0.5rem;
        }
        
        /* Cart checkout button */
          .cart__checkout-button {
            background: #000 !important;
            color: #fff !important;
            border: none !important;
            padding: 1rem 2rem !important;
            font-size: 1.25rem !important;
            font-weight: 600 !important;
          border-radius: 4px !important;
            cursor: pointer !important;
          width: 100% !important;
          }
          
          .cart__checkout-button span {
            font-size: 1.25rem !important;
            font-weight: 600 !important;
          }
          
          .cart__checkout-button:hover {
            background: #333 !important;
          }
          
          .cart__checkout-button:disabled {
            background: #ccc !important;
            cursor: not-allowed !important;
          }
        
        /* Improved cart totals styling - natural discount display */
        .cart-drawer__footer .totals {
          transition: all 0.3s ease;
        }
        
        .cart-drawer__footer .totals.savings {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 0.75rem 0 !important;
          margin: 0.5rem 0 !important;
        }
        
        .cart-drawer__footer .drawer__savings--amount {
          color: inherit !important;
          font-weight: 400 !important;
          font-size: inherit !important;
        }
        
        .cart-drawer__footer .totals.savings {
          font-size: inherit !important;
        }
        
        .cart-drawer__footer .totals.savings .totals__subtotal {
          font-size: inherit !important;
        }
        
        .cart-drawer__footer .drawer__total--amount {
          font-weight: 600 !important;
          font-size: 1.15em !important;
          color: inherit !important;
        }
        
        .cart-drawer__footer .drawer__subtotal--amount {
          color: #666 !important;
          font-weight: 400 !important;
        }
        
        /* Smooth transitions for price updates */
        .drawer__subtotal--amount,
        .drawer__savings--amount,
        .drawer__total--amount {
          transition: color 0.2s ease, transform 0.2s ease;
        }
        
        .drawer__total--amount {
          position: relative;
        }
        `;
        document.head.appendChild(style);
      
      console.log('✅ CheckoutHandler initialized (FR only)');
    }
    
    // Get cookie value (from pixel.js logic)
    getCookieValue(name) {
      const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
      return match ? match[2] : null;
    }
    
    // Get custom domain pixel from cookies
    getCustomDomainPixel() {
      const subdomainPixel = this.getCookieValue("sdp");
      const baseDomain = this.getCookieValue("domain");
      return subdomainPixel && baseDomain ? `${subdomainPixel}.${baseDomain}` : '';
    }
  
    init() {
      this.setupCartValidation();
      this.setupCartCheckoutRedirection();
      this.updateCartDisplay();
      this.setupLoadingOverlay();
    }
    
    // Setup loading overlay in cart
    setupLoadingOverlay() {
      // Create loading overlay if it doesn't exist
      const createOverlay = () => {
        const existing = document.querySelector('.cart-updating-overlay');
        if (existing) return existing;
        
        const overlay = document.createElement('div');
        overlay.className = 'cart-updating-overlay';
        overlay.innerHTML = '<div class="cart-loader"></div>';
        return overlay;
      };
      
      // Store reference
      this.loadingOverlay = createOverlay();
    }
    
    // Show loading state
    showLoading() {
      const cartSummary = document.querySelector('.cart-drawer__summary, .cart__summary-totals, .cart-summary');
      if (!cartSummary) return;
      
      // Ensure overlay exists and is attached
      if (!this.loadingOverlay.parentNode) {
        cartSummary.style.position = 'relative';
        cartSummary.appendChild(this.loadingOverlay);
      }
      
      // Show overlay
      this.loadingOverlay.classList.add('active');
      
      // Add shimmer to elements
      const bundleDiscount = document.querySelector('[data-bundle-discount]');
      const checkoutButton = document.querySelector('.cart__checkout-button');
      
      if (bundleDiscount) bundleDiscount.classList.add('cart-shimmer');
      if (checkoutButton) checkoutButton.classList.add('cart-shimmer');
    }
    
    // Hide loading state
    hideLoading() {
      if (this.loadingOverlay) {
        this.loadingOverlay.classList.remove('active');
      }
      
      // Remove shimmer
      document.querySelectorAll('.cart-shimmer').forEach(el => {
        el.classList.remove('cart-shimmer');
      });
    }
  
    // Setup cart validation for 60€ limit
    setupCartValidation() {
      // Intercept cart additions
      document.addEventListener('submit', async (e) => {
        const form = e.target;
        if (form.matches('[action="/cart/add"]')) {
          e.preventDefault();
          e.stopPropagation();
          
          try {
            const formData = new FormData(form);
            const variantId = formData.get('id');
            const quantity = parseInt(formData.get('quantity') || '1');
            
            // Check if adding this item would exceed limit
            const canAdd = await this.validateCartAddition(variantId, quantity);
            
            if (canAdd) {
              // Proceed with adding to cart
              const result = await this.addToCart(formData);
              
              // Trigger Shopify Analytics tracking after successful add
              if (result) {
                this.trackAddToCartAnalytics(variantId, formData);
              }
            } else {
              this.showError(this.texts.cartLimitError);
            }
          } catch (error) {
            console.error('Error adding to cart:', error);
          }
        }
      });
  
      // Monitor cart quantity changes
      document.addEventListener('change', async (e) => {
        const input = e.target;
        if (input.matches('input[name*="updates"]')) {
          const newQuantity = parseInt(input.value);
          const lineKey = input.name.match(/updates\[([^\]]+)\]/)?.[1];
          
          if (lineKey && newQuantity > 0) {
            const canUpdate = await this.validateCartUpdate(lineKey, newQuantity);
            
            if (!canUpdate) {
              this.showError(this.texts.cartLimitError);
              // Revert to previous value
              const cart = await this.getCart();
              const item = cart.items.find(i => i.key === lineKey);
              if (item) {
                input.value = item.quantity;
              }
              e.preventDefault();
            } else {
              // Quantity change is valid, wait for cart to update then refresh display
              console.log('📊 Quantity change valid, updating display...');
              setTimeout(() => {
                this.updateCartDisplay();
                document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'quantity' } }));
              }, 200);
            }
          }
        }
      });
      
      // Also listen for input events on quantity fields (for manual typing)
      document.addEventListener('input', debounce((e) => {
        const input = e.target;
        if (input.matches('input[name*="updates"]') || input.matches('input[type="number"]')) {
          console.log('📝 Quantity input detected');
          setTimeout(() => {
            this.updateCartDisplay();
          }, 200);
        }
      }, 300));
      
      // Monitor cart item removals
      document.addEventListener('click', async (e) => {
        const removeBtn = e.target.closest('.cart-items__remove, [data-cart-item-remove]');
        if (removeBtn) {
          console.log('🗑️ Item removal detected');
          // Show loading immediately
          this.showLoading();
          // Wait for removal to complete then refresh
          setTimeout(() => {
            this.updateCartDisplay();
            // Dispatch custom event
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'remove' } }));
          }, 300);
        }
      });
      
      // Monitor for cart form submissions (direct cart updates)
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (form.matches('[action="/cart"]') || form.matches('#cart-form')) {
          console.log('🔄 Cart form submitted');
          this.showLoading();
          setTimeout(() => {
            this.updateCartDisplay();
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'update' } }));
          }, 250);
        }
      });
  
      console.log('✅ Cart validation setup (60€ limit)');
    }
  
    // Validate if adding item would exceed 60€
    async validateCartAddition(variantId, quantity) {
      try {
        const cart = await this.getCart();
        const product = await this.getVariantInfo(variantId);
        
        if (!product) return false;
        
        // Calculate current cart total (original prices)
        let currentTotal = 0;
        for (const item of cart.items) {
          const itemProduct = await this.getProductByHandle(item.handle);
          const variant = itemProduct?.variants.find(v => v.id === item.variant_id);
          if (variant) {
            const price = this.getOriginalPrice(variant);
            currentTotal += price * item.quantity;
          }
        }
        
        // Add new item
        const newItemPrice = this.getOriginalPrice(product);
        const newTotal = currentTotal + (newItemPrice * quantity);
        
        return newTotal <= this.maxCartValue;
      } catch (error) {
        console.error('Error validating cart addition:', error);
        return false;
      }
    }
  
    // Validate if updating quantity would exceed 60€
    async validateCartUpdate(lineKey, newQuantity) {
      try {
        const cart = await this.getCart();
        
        // Calculate total with new quantity
        let total = 0;
        for (const item of cart.items) {
          const itemProduct = await this.getProductByHandle(item.handle);
          const variant = itemProduct?.variants.find(v => v.id === item.variant_id);
          if (variant) {
            const price = this.getOriginalPrice(variant);
            const qty = item.key === lineKey ? newQuantity : item.quantity;
            total += price * qty;
          }
        }
        
        return total <= this.maxCartValue;
        } catch (error) {
        console.error('Error validating cart update:', error);
        return false;
      }
    }
  
    // Track Add to Cart for Shopify Analytics
    async trackAddToCartAnalytics(variantId, formData) {
      try {
        const quantity = parseInt(formData.get('quantity') || '1');
        
        // Get product details for better analytics tracking
        let productInfo = null;
        try {
          const productHandle = formData.get('handle') || window.location.pathname.split('/products/')[1]?.split('?')[0];
          if (productHandle) {
            const productResponse = await fetch(`/products/${productHandle}.json`);
            if (productResponse.ok) {
              const productData = await productResponse.json();
              const variant = productData.product.variants.find(v => v.id.toString() === variantId.toString());
              if (variant) {
                productInfo = {
                  id: productData.product.id,
                  title: productData.product.title,
                  handle: productData.product.handle,
                  variant_id: variant.id,
                  variant_title: variant.title,
                  price: variant.price / 100,
                  quantity: quantity
                };
              }
            }
          }
        } catch (e) {
          console.warn('Could not fetch product details for analytics:', e);
        }
        
        // Trigger Shopify Analytics - multiple methods for compatibility
        if (typeof window.Shopify !== 'undefined') {
          // Method 1: Shopify Analytics API (if available)
          if (window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('productAddedToCart', {
              cart: {
                items: [{
                  variant_id: variantId,
                  quantity: quantity,
                  product_id: productInfo?.id || '',
                  product_handle: productInfo?.handle || ''
                }]
              }
            });
          }
          
          // Method 2: Dispatch custom event that Shopify Analytics might listen to
          document.dispatchEvent(new CustomEvent('shopify:cart:add', {
            detail: {
              variant_id: variantId,
              quantity: quantity,
              product: productInfo
            }
          }));
        }
        
        // Also trigger standard ecommerce events
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: this.currency,
              value: productInfo ? (productInfo.price * quantity) : 0,
              items: [{
                item_id: variantId.toString(),
                item_name: productInfo?.title || '',
                item_variant: productInfo?.variant_title || '',
                price: productInfo?.price || 0,
                quantity: quantity
              }]
            }
          });
        }
        
        console.log('📊 Analytics tracked: Add to Cart', { variantId, quantity, productInfo });
      } catch (error) {
        console.error('Error tracking analytics:', error);
      }
    }
    
    // Add item to cart
    async addToCart(formData) {
      try {
        // Show loading immediately
        this.showLoading();
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const result = await response.json();
          console.log('✅ Product added to cart:', result);
          
          // Show success message
          this.showSuccess('Produit ajouté au panier');
          
          // Dispatch both standard and custom events
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'add' } }));
          document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'add', item: result } }));
          
          // Open cart drawer immediately
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
          
          // Update display quickly
          setTimeout(() => {
            this.updateCartDisplay();
          }, 100);
          
          // Return result for analytics tracking
          return result;
        } else {
          this.hideLoading();
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        this.hideLoading();
        console.error('Error adding to cart:', error);
        throw error;
      }
    }
  
    // Get cart data
    async getCart() {
      const response = await fetch('/cart.json');
      return await response.json();
    }
  
    // Get variant info
    async getVariantInfo(variantId) {
      try {
        // Try to get from cart first
        const cart = await this.getCart();
        const cartItem = cart.items.find(i => i.variant_id.toString() === variantId.toString());
        
        if (cartItem) {
          const product = await this.getProductByHandle(cartItem.handle);
          return product?.variants.find(v => v.id.toString() === variantId.toString());
        }
        
        return null;
      } catch (error) {
        console.error('Error getting variant info:', error);
        return null;
      }
    }
  
    // Get product by handle
    async getProductByHandle(handle) {
      try {
          const response = await fetch(`/products/${handle}.json`);
          const data = await response.json();
        return data.product;
        } catch (error) {
        console.error('Error fetching product:', error);
        return null;
      }
    }
  
    // Get original price for a variant (use actual selling price, not compare_at)
    getOriginalPrice(variant) {
      // Use the actual price the customer pays
      let price = variant.price;
      
      // Ensure price is in cents
      if (price < 100) {
        price = Math.round(price * 100);
      }
      
      return price;
    }
  
    // Calculate tier for total amount (exact match or round DOWN to highest tier below total)
    calculateBottomTier(totalAmount) {
      // First, check if there's an exact match with a tier
      const exactMatch = this.tiers.find(tier => tier.price === totalAmount);
      if (exactMatch) {
        console.log(`💰 Cart total: ${this.formatPrice(totalAmount)} → Exact match: ${this.formatPrice(exactMatch.price)} (no discount)`);
        return exactMatch;
      }
      
      // If no exact match, find the highest tier price that's BELOW the cart total
      let selectedTier = this.tiers[0]; // Default to lowest tier (€2.00)
      
      for (const tier of this.tiers) {
        if (tier.price < totalAmount) {
          selectedTier = tier;
        } else {
          // Stop when we reach a tier that's >= total
          break;
        }
      }
      
      const discount = totalAmount - selectedTier.price;
      console.log(`💰 Cart total: ${this.formatPrice(totalAmount)} → Rounded to: ${this.formatPrice(selectedTier.price)} (discount: ${this.formatPrice(discount)})`);
      
      return selectedTier;
    }
  
    // Calculate cart totals with bundle discount
    async calculateCartTotals() {
      try {
        const cart = await this.getCart();
        
        if (cart.item_count === 0) {
          return {
            originalTotal: 0,
            tierTotal: 0,
            discount: 0
          };
        }
        
        // Calculate original total
        let originalTotal = 0;
        for (const item of cart.items) {
          const product = await this.getProductByHandle(item.handle);
          const variant = product?.variants.find(v => v.id === item.variant_id);
          if (variant) {
            const price = this.getOriginalPrice(variant);
            originalTotal += price * item.quantity;
          }
        }
        
        // Find bottom tier
        const tier = this.calculateBottomTier(originalTotal);
        const tierTotal = tier.price;
        const discount = originalTotal - tierTotal;
        
        return {
          originalTotal,
          tierTotal,
          discount: discount > 0 ? discount : 0
        };
         } catch (error) {
        console.error('Error calculating cart totals:', error);
        return {
          originalTotal: 0,
          tierTotal: 0,
          discount: 0
        };
      }
    }
  
    // Update cart display with bundle discount
    async updateCartDisplay() {
      try {
        // Show loading immediately
        this.showLoading();
        
        const totals = await this.calculateCartTotals();
        
        console.log('🔄 Updating cart display:', totals);
        
        if (totals.tierTotal === 0) {
          console.log('⚠️ Cart is empty, skipping update');
          this.hideLoading();
          return;
        }
        
        // Update cart summary
        this.updateCartSummary(totals);
        
        // Update checkout button
        this.updateCheckoutButton(totals);
        
        // Hide loading after a brief delay to avoid flashing
        setTimeout(() => {
          this.hideLoading();
        }, 100);
        
      } catch (error) {
        console.error('❌ Error updating cart display:', error);
        this.hideLoading();
      }
    }
  
    // Update cart summary with bundle discount - improved UX/UI
    updateCartSummary(totals) {
      // Update subtotal (original total before discount)
      const subtotalElements = document.querySelectorAll('.drawer__subtotal--amount, [data-cart-subtotal]');
      subtotalElements.forEach(el => {
        el.textContent = this.formatPrice(totals.originalTotal);
      });
      
      // Update savings display (show discount naturally)
      const savingsContainer = document.querySelector('.totals.savings');
      const savingsAmount = document.querySelector('.drawer__savings--amount');
      
      if (totals.discount > 0) {
        // Show savings section if it exists
        if (savingsContainer) {
          savingsContainer.style.display = 'flex';
          savingsContainer.style.justifyContent = 'space-between';
          savingsContainer.style.alignItems = 'center';
        }
        
        // Update savings amount with natural formatting
        if (savingsAmount) {
          savingsAmount.textContent = `-${this.formatPrice(totals.discount)}`;
          savingsAmount.style.color = 'inherit';
          savingsAmount.style.fontWeight = '400';
        }
      } else {
        // Hide savings if no discount
        if (savingsContainer) {
          savingsContainer.style.display = 'none';
        }
      }
      
      // Update final total (tier price - the actual amount to pay)
      this.updateTotalDisplays(totals);
      
      console.log(`✅ Cart updated: ${this.formatPrice(totals.originalTotal)} → ${this.formatPrice(totals.tierTotal)} (savings: ${this.formatPrice(totals.discount)})`);
    }
  
    // Update total price displays - natural integration
    updateTotalDisplays(totals) {
      // Update main total display in cart drawer
      const totalElements = document.querySelectorAll(
        '.drawer__total--amount, ' +
        '.totals__subtotal-value:not(.drawer__subtotal--amount):not(.drawer__savings--amount), ' +
        '[data-cart-total]'
      );
      
      totalElements.forEach(element => {
        // Only update if it's in a totals container (to avoid updating wrong elements)
        const isTotalElement = element.closest('.totals') && 
                              !element.classList.contains('drawer__subtotal--amount') &&
                              !element.classList.contains('drawer__savings--amount');
        
        if (isTotalElement || element.classList.contains('drawer__total--amount')) {
          element.textContent = this.formatPrice(totals.tierTotal);
          // Make total stand out slightly
          element.style.fontWeight = '600';
          element.style.fontSize = '1.1em';
        }
      });
      
      // Also update any cart summary totals
      const cartSummaryTotals = document.querySelectorAll('.cart-summary .totals__subtotal-value, .cart__summary .totals__subtotal-value');
      cartSummaryTotals.forEach(el => {
        if (!el.classList.contains('drawer__subtotal--amount') && 
            !el.classList.contains('drawer__savings--amount')) {
          el.textContent = this.formatPrice(totals.tierTotal);
        }
      });
      
      console.log(`💰 Final total displayed: ${this.formatPrice(totals.tierTotal)}`);
    }
  
    // Update checkout button with price - ensure it matches final total
    updateCheckoutButton(totals) {
      // Try multiple selectors to find checkout button
      const checkoutBtn = document.querySelector('#checkout, .cart__checkout-button, #CartDrawer-Checkout, button[name="checkout"]');
      if (!checkoutBtn) {
        console.warn('⚠️ Checkout button not found');
        return;
      }
      
      // Only update if we have a valid total
      if (totals.tierTotal > 0) {
        const baseText = this.texts.cartCheckout || 'COMMANDER';
        const finalPrice = this.formatPrice(totals.tierTotal);
        
        // Update button text - preserve any existing structure
        const existingSpan = checkoutBtn.querySelector('span');
        if (existingSpan) {
          existingSpan.textContent = `${baseText} - ${finalPrice}`;
        } else {
          checkoutBtn.innerHTML = `<span>${baseText} - ${finalPrice}</span>`;
        }
        
        // Ensure button styling
        checkoutBtn.style.fontWeight = '600';
        
        // Make sure button is enabled if cart has items
        if (checkoutBtn.disabled && totals.tierTotal > 0) {
          checkoutBtn.disabled = false;
        }
        
        console.log(`🛒 Checkout button updated: ${baseText} - ${finalPrice}`);
      }
    }
  
    // Track Reached Checkout for Shopify Analytics
    trackReachedCheckout(cart, totals) {
      try {
        // Prepare cart items for analytics
        const cartItems = cart.items.map(item => ({
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
          price: item.final_price / 100,
          title: item.product_title,
          variant_title: item.variant_title || ''
        }));
        
        // Trigger Shopify Analytics - multiple methods for compatibility
        if (typeof window.Shopify !== 'undefined') {
          // Method 1: Shopify Analytics API (if available)
          if (window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('checkoutInitiated', {
              cart: {
                total_price: totals.tierTotal / 100,
                item_count: cart.item_count,
                items: cartItems
              }
            });
          }
          
          // Method 2: Dispatch custom event that Shopify Analytics might listen to
          document.dispatchEvent(new CustomEvent('shopify:checkout:initiated', {
            detail: {
              cart: cart,
              totals: totals,
              items: cartItems
            }
          }));
        }
        
        // Also trigger standard ecommerce events
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
              currency: this.currency,
              value: totals.tierTotal / 100,
              items: cartItems.map(item => ({
                item_id: item.variant_id.toString(),
                item_name: item.title,
                item_variant: item.variant_title,
                price: item.price,
                quantity: item.quantity
              }))
            }
          });
        }
        
        console.log('📊 Analytics tracked: Reached Checkout', { cartItems, total: totals.tierTotal / 100 });
      } catch (error) {
        console.error('Error tracking checkout analytics:', error);
      }
    }
    
    // Setup checkout button redirection
      setupCartCheckoutRedirection() {
        document.addEventListener('click', async (e) => {
          const checkoutBtn = e.target.closest('#checkout, .cart__checkout-button, #CartDrawer-Checkout, button[name="checkout"]');
          if (!checkoutBtn) return;
          
            e.preventDefault();
            e.stopPropagation();
          
          try {
          const cart = await this.getCart();
            
          if (cart.item_count === 0) {
              console.log('🛒 Cart is empty');
              return;
            }
            
          const totals = await this.calculateCartTotals();
          
          // Track "Reached Checkout" event before redirecting
          this.trackReachedCheckout(cart, totals);
          
          // Build checkout URL
          const checkoutUrl = this.buildCheckoutUrl(totals, cart);
          
          // Redirect to checkout (logs are preserved in buildCheckoutUrl)
          console.log('🚀 Redirecting to checkout:', checkoutUrl);
          window.location.href = checkoutUrl;
            
          } catch (error) {
            console.error('Error during checkout:', error);
          this.showError('⚠️ Erreur de commande. Veuillez réessayer.');
        }
      });
    }
  
    // Build checkout URL
    buildCheckoutUrl(totals, cart) {
      // Get first item for variant ID
      const firstItem = cart.items[0];
      const variantId = firstItem.variant_id || '';
      
      // Convert prices to euros
      const productPrice = (totals.tierTotal / 100).toFixed(2); // Tier-rounded price
      const productOriginalPrice = (totals.originalTotal / 100).toFixed(2); // Original cart total
      
      // Get custom domain pixel from cookies
      const customDomainPixel = this.getCustomDomainPixel();
      
      // Product info (using first product's image)
      const productName = 'Total';
      const productImage = 'https://cdn.shopify.com/s/files/1/0931/0751/9875/files/ChatGPT_Image_Nov_14_2025_03_34_04_PM.png?v=1763130857';
      const productTags = '';
      
      // Build the checkout URL
      const checkoutUrl = `https://checkout.${this.sourceId}/c/checkout?` +
        `sn=${encodeURIComponent(this.sourceId)}` +
        `&p_name=${encodeURIComponent(productName)}` +
        `&p_image=${encodeURIComponent(productImage)}` +
        `&p_cprice=${productPrice}` +
        `&p_oprice=${productOriginalPrice}` +
        `&currency=${this.currency}` +
        `&logo=${encodeURIComponent(this.logoUrl)}` +
        `&color=${encodeURIComponent(this.shopColor)}` +
        `&reviews=${encodeURIComponent(this.shopReviews)}` +
        `&tags=${encodeURIComponent(productTags)}` +
        `&variant_id=${variantId}` +
        `&fb=${this.fbPixelId}` +
        `&tt=` +
        `&cdp=${encodeURIComponent(customDomainPixel)}` +
        `&tp=${encodeURIComponent(this.trackingPixel)}`;
      
      console.log(`🔗 Building checkout URL: ${this.formatPrice(totals.tierTotal)} (${productPrice}€)`);
      console.log(`📊 Full Checkout URL:`, checkoutUrl);
      console.log(`\n📋 URL Parameters:`);
      console.log(`  - Source: ${this.sourceId}`);
      console.log(`  - Current Price (p_cprice): ${productPrice}€`);
      console.log(`  - Original Price (p_oprice): ${productOriginalPrice}€`);
      console.log(`  - Discount: ${(productOriginalPrice - productPrice).toFixed(2)}€`);
      console.log(`  - Variant ID: ${variantId}`);
      console.log(`  - Custom Domain Pixel: ${customDomainPixel || 'none'}`);
      console.log(`  - Tracking Pixel: ${this.trackingPixel}`);
      
      return checkoutUrl;
    }
  
    // Format price for display
    formatPrice(priceInCents) {
      const price = priceInCents / 100;
      return `${price.toFixed(2).replace('.', ',')}€`;
    }
  
    // Show error message
    showError(message) {
      // Remove existing messages
      document.querySelectorAll('.cart-error-message, .cart-success-message').forEach(el => el.remove());
      
      // Create error message
          const errorDiv = document.createElement('div');
      errorDiv.className = 'cart-error-message';
      errorDiv.innerHTML = `<span>${message}</span>`;
          document.body.appendChild(errorDiv);
          
      console.log('❌ Error shown:', message);
      
      // Auto-hide after 4 seconds
          setTimeout(() => {
        errorDiv.style.animation = 'errorSlideUp 0.4s ease-out forwards';
            setTimeout(() => {
              if (errorDiv.parentNode) {
                errorDiv.remove();
              }
            }, 400);
          }, 4000);
    }
    
    // Show success message
    showSuccess(message) {
      // Remove existing messages
      document.querySelectorAll('.cart-error-message, .cart-success-message').forEach(el => el.remove());
      
      // Create success message
      const successDiv = document.createElement('div');
      successDiv.className = 'cart-success-message';
      successDiv.innerHTML = `<span>${message}</span>`;
      document.body.appendChild(successDiv);
      
      console.log('✅ Success shown:', message);
      
      // Auto-hide after 2.5 seconds
      setTimeout(() => {
        successDiv.style.animation = 'errorSlideUp 0.4s ease-out forwards';
        setTimeout(() => {
          if (successDiv.parentNode) {
            successDiv.remove();
          }
        }, 400);
      }, 2500);
      }
    }
    
  // Initialize the checkout handler
  function initializeCheckoutHandler() {
    if (window.checkoutHandler) {
      console.log('🔄 Checkout handler already exists');
      return;
    }
    
    window.checkoutHandler = new CheckoutHandler();
    console.log('✅ Checkout handler initialized (FR only, 60€ limit)');
    
    // Debounce function for cart updates
    let updateTimeout = null;
    const debouncedUpdate = () => {
      if (updateTimeout) clearTimeout(updateTimeout);
      updateTimeout = setTimeout(() => {
        if (window.checkoutHandler) {
          window.checkoutHandler.updateCartDisplay();
        }
      }, 100);
    };
    
    // Handle cart updates (Shopify theme events)
    document.addEventListener('cart:updated', (e) => {
      console.log('🔄 Cart updated event:', e.detail);
      debouncedUpdate();
    });
    
    // Handle section reloads
    document.addEventListener('shopify:section:load', () => {
      console.log('🔄 Section loaded, refreshing display...');
      debouncedUpdate();
    });
    
    // Listen for custom cart change events (from cart API)
    document.addEventListener('cart:change', () => {
      console.log('🔄 Cart change detected');
      debouncedUpdate();
    });
    
    // Listen for Shopify theme cart events
    if (typeof Shopify !== 'undefined' && Shopify.theme) {
      document.addEventListener('theme:cart:change', () => {
        console.log('🔄 Theme cart change detected');
        debouncedUpdate();
      });
    }
    
    // Watch for cart drawer opening and DOM changes
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      
      for (const mutation of mutations) {
        // Check if cart drawer opened
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (target.matches && (target.matches('cart-drawer') || target.matches('.cart-drawer') || target.matches('[data-cart-drawer]'))) {
            if (target.classList.contains('active') || target.hasAttribute('open') || target.open) {
              console.log('🔄 Cart drawer opened');
              shouldUpdate = true;
              break;
            }
          }
        }
        
        // Check if cart content changed
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasCartContent = addedNodes.some(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            return node.matches && (
              node.matches('.cart-items') ||
              node.matches('[data-bundle-discount]') ||
              node.matches('.cart__summary-totals') ||
              node.querySelector('.cart-items, [data-bundle-discount], .cart__summary-totals')
            );
          });
          
          if (hasCartContent) {
            console.log('🔄 Cart content changed');
            shouldUpdate = true;
            break;
          }
        }
      }
      
      if (shouldUpdate) {
        debouncedUpdate();
      }
    });
    
    // Observe the document for cart-related changes
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'open'],
      childList: true,
      subtree: true
    });
    
    // Initial cart check
    setTimeout(() => {
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      if (cartDrawer && window.checkoutHandler) {
        console.log('🔄 Initial cart check...');
        window.checkoutHandler.updateCartDisplay();
      }
    }, 200);
    
    // Store observer for cleanup
    window.checkoutHandler.domObserver = observer;
    
    // Periodic check to ensure cart stays synchronized (fallback)
    let lastCartState = null;
    const periodicCheck = setInterval(async () => {
      // Only check if cart drawer is visible
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      if (!cartDrawer) return;
      
      const isOpen = cartDrawer.classList.contains('active') || 
                     cartDrawer.hasAttribute('open') || 
                     cartDrawer.open ||
                     (cartDrawer.querySelector && cartDrawer.querySelector('[open]'));
      
      if (!isOpen) return;
      
      try {
        const cart = await fetch('/cart.json').then(r => r.json());
        const currentState = JSON.stringify({
          count: cart.item_count,
          total: cart.total_price,
          items: cart.items.map(i => ({ id: i.id, qty: i.quantity }))
        });
        
        if (lastCartState && lastCartState !== currentState) {
          console.log('🔄 Periodic check detected cart change');
          debouncedUpdate();
        }
        
        lastCartState = currentState;
      } catch (error) {
        console.error('Periodic check error:', error);
      }
    }, 1500); // Check every 1.5 seconds when cart is open
    
    // Store interval for cleanup
    window.checkoutHandler.periodicCheckInterval = periodicCheck;
  }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCheckoutHandler);
    } else {
      initializeCheckoutHandler();
    }
    
  // Also initialize on page show (for back/forward navigation)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      console.log('🔄 Page restored from cache, reinitializing...');
      setTimeout(initializeCheckoutHandler, 100);
    }
  });
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (window.checkoutHandler) {
      if (window.checkoutHandler.domObserver) {
        window.checkoutHandler.domObserver.disconnect();
      }
      if (window.checkoutHandler.periodicCheckInterval) {
        clearInterval(window.checkoutHandler.periodicCheckInterval);
      }
      console.log('✅ CheckoutHandler cleanup complete');
    }
  });
  